import { render, staticRenderFns } from "./DistributionDashboard.vue?vue&type=template&id=3b5ea9cb&scoped=true&"
import script from "./DistributionDashboard.vue?vue&type=script&lang=js&"
export * from "./DistributionDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5ea9cb",
  null
  
)

export default component.exports